<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BaseCheckboxList',
  mixins: [baseMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    preselect: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemLabel: {
      type: String,
      default: 'name',
    },
  },
  data: () => {
    return {
      selected: [],
    }
  },
  watch: {
    preselect(n) {
      this.selected = n
    },
  },
  mounted() {
    this.selected = this.preselect
  },
}
</script>

<template>
  <article>
    <v-checkbox
      v-for="item in items"
      :key="item[itemValue]"
      v-model="selected"
      :label="item[itemLabel]"
      :value="item[itemValue]"
      class="mb-0 mt-2 base-checkbox__list-item"
      hide-details
      @change="$emit('updated', selected)"
    />
  </article>
</template>
